export default __webpack_public_path__ + "static/media/green.eec3ff5b.svg";